/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.24/esri/copyright.txt for details.
*/
function r(r,e){return r.isGeographic||r.isWebMercator&&(e?.geographic??!0)}export{r as isGeographicMesh};
